import React from "react";
import Navbar from "../../_Layouts/Navbar/Navbar";
import ODFS from "../../Components/Odfs/Odfs";

const OdfPage = () => {
  return (
    <div>
      <Navbar titre={"Ordres de fabrication"} />
      <div className="page-container">
        <ODFS />
      </div>
    </div>
  );
};

export default OdfPage;
